export const IDEA_BOX = 'idea_box';
export const WHISTLE_BLOWER = 'whistle_blower';
